module.exports = __webpack_public_path__ + "img/gb13871-92_150x180x15.prt.1c63ec85.jpg";